import styled from '@emotion/styled'

export const Container = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  width: 400px;
  margin: auto;
  top: 20px;
  z-index: 1000;
  display: flex;
  align-items: center;
  background-color: white;
  padding: 8px;
  border-radius: 8px;
`
